
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...landingSlug]",
      function () {
        return require("private-next-pages/[...landingSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...landingSlug]"])
      });
    }
  